<app-auth>
  <app-loader [loading]="loading()">
      <p-confirm-dialog></p-confirm-dialog>
      <div class="h-full">
        <header class="navbar-container">
          <app-navbar [mobileItems]="menuItems" [userItems]="userItems" [timezone]="timezone" (timezoneSet)="onTimezoneSet()"></app-navbar>
        </header>
        <aside class="hidden md:block sidepanel-container">
          <app-sidepanel [actualRoute]="actualRoute" [disableRoutes]="['/', '/home']"
            [items]="menuItems"></app-sidepanel>
        </aside>
        <main class="content-container">
          <div class="py-6">
            @if (!loading() && timezoneLoaded()) {
              <router-outlet></router-outlet>
            }
          </div>
        </main>
        <footer class="footer-container">
          <app-footer></app-footer>
        </footer>
      </div>
  </app-loader>

  <p-toast [life]="5000"></p-toast>
</app-auth>